/**
 * DOM id of the authenticated shell's content wrapper (header + sidebar + page).
 *
 * A modal overlay marks this `inert` while it is open, so the rest of the app is
 * genuinely unreachable rather than merely claiming to be via `aria-modal`. The
 * overlay itself must therefore render OUTSIDE this element — portal it to
 * `document.body`, or it would make itself inert too.
 */
export const APP_CONTENT_ID = 'app-content';

/**
 * DOM id of the md+ sidebar.
 *
 * The collapse toggle points its `aria-controls` here, so assistive tech can tie
 * the button's `aria-expanded` to the region it actually resizes.
 */
export const SIDEBAR_ID = 'app-sidebar';
